import { Button } from '../interactive/button.jsx';

/**
 * Shared pill/chip used by tag displays, the tag picker, and the filter bar.
 * @param {Object} props
 * @param {string} [props.label] - muted prefix, e.g. "Tags:"
 * @param {import('react').ReactNode} props.children - the value shown
 * @param {() => void} [props.onClick]
 * @param {() => void} [props.onRemove]
 * @param {string} [props.removeLabel]
 * @param {'default'|'success'|'muted'} [props.variant]
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
export function Pill({ label, children, onClick, onRemove, removeLabel, variant, className }) {
	const variantCls = variant && variant !== 'default' ? ' is-' + variant : '';
	return (
		<span className={`pill${variantCls}${className ? ' ' + className : ''}`} onClick={onClick}>
			{label && <span className="pill-label">{label}</span>}
			<span className="pill-value">{children}</span>
			{onRemove && (
				<Button className="pill-remove" onClick={onRemove} aria-label={removeLabel}>
					&times;
				</Button>
			)}
		</span>
	);
}
